import { ROUTE_PATH } from './constant';
import { lazy } from 'react';
import { Route } from 'types/index';

const HomePage = lazy(() => import(/* webpackChunkName: "HomePage" */ 'pages/Homepage'));
const Login = lazy(() => import(/* webpackChunkName: "Login" */ 'pages/Login'));
const TermsAndCondition = lazy(() => import(/* webpackChunkName: "TermsAndCondition" */ 'pages/TermsAndCondition'));
const SuccessLinkPage = lazy(() => import(/* webpackChunkName: "SuccessLinkPage" */ 'pages/SuccessLinkPage'));
const SignUp = lazy(() => import(/* webpackChunkName: "SignUp" */ 'pages/SignUp'));
const Welcome = lazy(() => import(/* webpackChunkName: "Welcome" */ 'pages/Welcome'));
const ForgotPassword = lazy(() => import(/* webpackChunkName: "ForgotPassword" */ 'pages/ForgotPassword'));
const ForgotPasswordSuccess = lazy(() => import(/* webpackChunkName: "ForgotPasswordSuccess" */ 'pages/ForgotPasswordSuccess'));

export const routes: Route[] = [
  {
    path: ROUTE_PATH.HOME,
    component: HomePage,
    exact: true,
    pageTitle: 'HomePage',
    key: 'HomePage',
    checkLogin: true,
  },
  {
    path: ROUTE_PATH.LOGIN,
    component: Login,
    pageTitle: 'Login',
    key: 'Login',
  },
  {
    path: ROUTE_PATH.SIGN_UP,
    component: SignUp,
    pageTitle: 'Sign up',
    key: 'SignUp',
  },
  {
    path: ROUTE_PATH.TERMS_AND_CONDITION,
    component: TermsAndCondition,
    pageTitle: 'Terms and condition',
    key: 'TERMS_AND_CONDITION',
  },
  {
    path: ROUTE_PATH.SUCCESS_LINK_PAGE,
    component: SuccessLinkPage,
    pageTitle: 'Success link page',
    key: 'SUCCESS_LINK_PAGE',
  },
  {
    path: ROUTE_PATH.WELCOME,
    component: Welcome,
    pageTitle: 'Welcome',
    key: 'WELCOME',
  },
  {
    path: ROUTE_PATH.FORGOT_PASSWORD,
    component: ForgotPassword,
    pageTitle: 'ForgotPassword',
    key: 'ForgotPassword',
  },
  {
    path: ROUTE_PATH.FORGOT_PASSWORD_SUCCESS,
    component: ForgotPasswordSuccess,
    pageTitle: 'ForgotPasswordSuccess',
    key: 'ForgotPasswordSuccesss',
  },
];
